import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import StarsBackground from "@/components/landing/StarsBackground";
import FooterCTA from "@/components/landing/FooterCTA";
import Pricing from "@/components/landing/Pricing";
import PricingFAQ from "@/components/landing/PricingFAQ";
import { track } from "@/lib/track-lazy";

const PricingPage = () => {
  useEffect(() => {
    track("Pricing Page Viewed");
  }, []);

  return (
    <div className="min-h-screen bg-background relative">
      <StarsBackground />
      <div className="relative z-10">
        <Navbar />
        <main className="pt-16">
          <Pricing />
          <PricingFAQ />
          <FooterCTA />
        </main>
      </div>
    </div>
  );
};

export const head = {
  title: "AntAtlas Pricing — Team $390, Business $1,490, Enterprise from $4,500",
  description:
    "Honest 4-tier pricing for AntAtlas. 4-week pilot is free. Team $390/mo, Business $1,490/mo, Enterprise from $4,500/mo (or $2,900 BYOK). YC alumni get 50% off Team for the first 12 months.",
  path: "/pricing",
  image: "/og-pricing.png",
};

export default PricingPage;
